import React from "react";
import { Box, Stack, Typography, useMediaQuery, useTheme } from "@mui/material";

interface InfoCardProps {
  icon: React.ReactNode;
  title: string;
  info: string;
}

export const InfoCard = ({ icon, title, info }: InfoCardProps) => {
  return (
    <Box
      sx={{
        flex: 1,
        borderRadius: "12px",
        padding: { xs: "20px", lg: "24px" },
        border: "1px solid white",
        display: "flex",
        flexDirection: "column",
        gap: { xs: "10px", lg: "12px" },
        minWidth: { xs: "100%", sm: "260px" },
      }}
    >
      <Box 
        sx={{ 
          width: "40px",
          height: "40px",
          borderRadius: "50%",
          border: "1px solid white",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {icon}
      </Box>
      
      <Typography
        fontSize="18px"
        fontWeight={600}
        lineHeight="24px"
        color="#fff"
      >
        {title}
      </Typography>
      
      <Typography
        fontSize="14px"
        lineHeight="20px"
        color="rgba(255,255,255,0.9)"
      >
        {info}
      </Typography>
    </Box>
  );
};